import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

/**
 * Hook to opt out of a campaign using Member Gateway SDK
 */
export function useOptOutCampaign() {
  const queryClient = useQueryClient();

  return useApiMutation({
    mutationFn: (api) => async (campaignId: number) => {
      await api.campaigns.campaignsControllerOptMemberOutOfCampaign(campaignId);
    },
    onSuccess: (_data, campaignId) => {
      queryClient.invalidateQueries({ queryKey: campaignKeys.lists() });
      queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) });
    },
  });
}
